class oGiftCardBalance extends HTMLDivElement {
    constructor() {
        super();
        this.giftCardBalance = document.querySelectorAll('[is="o-gift-card-balance"]');
        this.giftCardBalanceForm = document.getElementById('giftCardBalanceForm');
        this.giftCardBalanceFormSubmit = document.getElementById('giftCardBalance-form-submit');
        this.giftCardInput = document.getElementById('giftCardBalanceInput');
        this.giftCardInputWrapper = document.getElementsByClassName('input-wrapper');
        this.giftCardBalanceInfoContainer = document.getElementById('giftCardBalanceInfo');
        this.errorMessage = document.getElementById('giftCardBalancePaymentMsgError');
        this.balanceErrorMessage = document.getElementById('giftCardBalanceErrorMsg');
        this.number = document.getElementById('giftCardBalanceInfoNumber');
        this.expire = document.getElementById('giftCardBalanceInfoExpire');
        this.amount = document.getElementById('giftCardBalanceInfoAmount');
        this.balance = document.getElementById('giftCardBalanceInfoBalance');
        this.backToForm = document.getElementById('backToForm');
        this.greyOverlay = document.getElementById('grey-overlay');

        this.submitGiftCardCode = this.submitGiftCardCode.bind(this);
        this.showGiftCardBalanceInfo = this.showGiftCardBalanceInfo.bind(this);
        this.hideGiftCardBalanceInfo = this.hideGiftCardBalanceInfo.bind(this);
    }

    connectedCallback() {
        this.giftCardBalanceForm.addEventListener('submit', this.submitGiftCardCode);
        this.backToForm.addEventListener('click', this.hideGiftCardBalanceInfo);
    }

    submitGiftCardCode(e) {
        e.preventDefault();

        fetch(this.giftCardBalanceForm.action, {
            method: 'POST',
            body: new FormData(this.giftCardBalanceForm),
        }).then((response) => response.json()).then((data) => {
            if (data.error) {
                this.errorMessage.textContent = data.message;
                this.giftCardInputWrapper[0].classList.add('error');
            } else {
                this.showGiftCardBalanceInfo(data);
            }
        });
    }

    showGiftCardBalanceInfo(data) {
        if (data) {
            this.number.textContent = `#${data.giftCertificateCode}`;
            this.expire.textContent = data.expire;
            if (data.giftCertificateInfo.isExpired) {
                this.expire.classList.add('error');
            }
            this.amount.textContent = data.initialAmount;
            this.balance.textContent = data.balance;
            if (data.giftCertificateInfo.isEmpty) {
                this.balance.classList.add('error');
            }
            this.giftCardBalanceForm.classList.add('d-none');
            this.giftCardBalanceInfoContainer.classList.remove('d-none');
            this.errorMessage.classList.remove('active');
            if (data.message !== '') {
                this.balanceErrorMessage.textContent = data.message;
                this.greyOverlay.style.display = 'block';
            }
        }
    }

    hideGiftCardBalanceInfo() {
        this.number.textContent = '';
        this.expire.textContent = '';
        this.expire.classList.remove('error');
        this.amount.textContent = '';
        this.balance.textContent = '';
        this.balance.classList.remove('error');
        this.giftCardInput.value = '';
        this.giftCardBalanceForm.classList.remove('d-none');
        this.giftCardBalanceInfoContainer.classList.add('d-none');
        this.errorMessage.classList.remove('active');
        this.balanceErrorMessage.textContent = '';
        this.greyOverlay.style.display = 'none';
    }
}

customElements.define('o-gift-card-balance', oGiftCardBalance, {
    extends: 'div',
});
